<template>
  <div
    v-if="mention"
    class="column no-wrap mention scoped scroll grow"
    style="flex: 1"
  >
    <div v-if="header">
      <div
        class="row items-center justify-between"
        :class="['bg-primary', `bg-${medium}`]"
      >
        <QBtn
          :aria-label="$t('global.back')"
          class="back-btn text-white"
          flat
          @click="$emit('close')"
        >
          <QIcon
            class="q-px-md"
            name="ion-ios-arrow-back"
          />
          <span>{{ $t("global.back") }}</span>
        </QBtn>
        <ActionSheet
          button-color="white"
          class="mention-dropdown"
          :mention="mention"
          :origin="origin"
          :stream="stream"
          @mention-removed="$emit('mention-removed', $event)"
        />
      </div>
    </div>
    <div
      class="column scroll full-height"
      :class="bodyClass"
    >
      <ArticlePreview
        v-if="mention.type === 'article'"
        :id="mention.id"
        article-type="article"
        :keywords="keywords"
      />
      <TvPreview
        v-else-if="isTvMention"
        :id="mention.id"
        :keywords="keywords"
        :on-screen-keywords="tvSuperKeywords"
        :origin="origin"
        :stream="stream"
        :tv-type="mention.type"
      />
      <TvSegmentPreview
        v-else-if="
          mention.type === 'tv_media_request' ||
          (mention.object && mention.object.type === 'tv_media_request')
        "
        :segment="mention"
      />
    </div>
  </div>
</template>

<script>
import { storeToRefs } from "pinia";

import ArticlePreview from "shared/components/streams/preview/ArticlePreview.vue";
import TvPreview from "shared/components/streams/preview/TvPreview.vue";
import TvSegmentPreview from "shared/components/streams/preview/TvSegmentPreview.vue";
import { mentionKeywords } from "shared/helpers/mentions";
import { useUniversalSearchStore } from "shared/stores/universalSearch";

export default {
  name: "MentionPreview",
  components: {
    TvSegmentPreview,
    ArticlePreview,
    TvPreview,
  },
  props: {
    mention: {
      type: Object,
      required: true,
    },
    header: {
      type: Boolean,
    },
    bodyClass: {
      type: [Array, Object, String],
      default: "",
    },
    stream: {
      type: Object,
      required: true,
    },
  },
  emits: ["close", "mention-removed"],
  setup() {
    const universalSearchStore = useUniversalSearchStore();
    const { searchOpen } = storeToRefs(universalSearchStore);

    return { searchOpen };
  },
  computed: {
    medium() {
      return this.mention.medium?.toLowerCase();
    },
    keywords() {
      if (this.mention.type === "tv_caption") return this.captionKeywords;

      return mentionKeywords(this.mention);
    },
    tvSuperKeywords() {
      const excerpts = this.mention.excerpts.filter(
        (excerpt) => excerpt.type === "tv_super"
      );

      const keywords = excerpts.map((excerpt) => excerpt.keywords).flat();

      return keywords.filter(
        (value, index, self) => self.indexOf(value) === index
      );
    },
    captionKeywords() {
      const excerpts = this.mention.excerpts.filter(
        (excerpt) => excerpt.type !== "tv_super"
      );

      return excerpts.map((excerpt) => excerpt.keywords).flat();
    },
    origin() {
      if (this.stream.id) {
        return {
          origin_id: this.stream.id,
          origin_type: "Stream",
          origin_keyword: this.keywords[0],
        };
      }

      if (this.searchOpen) {
        return {
          origin_type: "Search",
          origin_keyword: this.keywords[0],
        };
      }

      if (this.stream.folderId) {
        return {
          origin_id: this.stream.folderId,
          origin_type: "Folder",
          origin_keyword: this.keywords[0],
        };
      }

      return {};
    },
    isTvMention() {
      return ["tv_caption", "tv_super", "tv_logo_appearance"].includes(
        this.mention.type
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.scoped {
  :deep(.player) {
    margin: 0 8px;
  }

  :deep(.back-btn .q-btn__wrapper) {
    padding: 0;
  }
}
</style>
